import { useState } from "react"
import { Input } from "reactstrap"
import MainButton from "../../Component/Button/MainButton"
import LoadingScreen from "../../Component/Loader/LoadingScreen"
import { urlQueryParamsHandler, verifyLength } from "../../Service/Helper/Utils"
import logo from "./../../public/img/logo.png"
import { useNavigate, useSearchParams } from "react-router-dom"

function ResetPassword() {
    const navigation = useNavigate()
    const [searchParams] = useSearchParams()
    const id = urlQueryParamsHandler(searchParams.get("id"))
    const token = urlQueryParamsHandler(searchParams.get("token"))
    const [isLoad, setIsLoad] = useState(false)
    const [password, setPassword] = useState("")
    const [retypePass, setRetypePass] = useState("")
    const [visible, setVisible] = useState(false)
    const hasResetToken = Boolean(token)

    function handleClick () {
        if (!hasResetToken) {
            navigation("/forgot")
            return
        }

        if (!password || !retypePass) {
            window.alert("Lengkapi password dan konfirmasi password.")
            return
        }

        if (password !== retypePass) {
            window.alert("Konfirmasi password belum sama.")
            return
        }

        setIsLoad(true)
        window.alert("Reset password mandiri belum aktif. Silakan hubungi admin untuk menyelesaikan reset password.")
        navigation(id ? `/login?id=${id}` : "/login")
        setIsLoad(false)
    }

    const children = (
        <main className="public-auth-page">
            <section className="public-auth-hero">
                <div className="landing-container public-auth-grid">
                    <div className="public-auth-copy">
                        <div className="landing-brand-chip">
                            <img src={logo} alt="Goodnet Logo" />
                            <span>Goodnet By Artamedia</span>
                        </div>
                        <h1>Reset password pelanggan.</h1>
                        <p>Gunakan link reset yang diberikan admin untuk membuat password baru akun pelanggan.</p>
                        <div className="landing-proof-grid">
                            <div><strong>Token</strong><span>Link reset sekali pakai</span></div>
                            <div><strong>Validasi</strong><span>Password harus dikonfirmasi</span></div>
                            <div><strong>Akses</strong><span>Kembali login setelah reset</span></div>
                        </div>
                    </div>

                    <div className="public-auth-card">
                        <div className="public-auth-card-head">
                            <span>Reset password</span>
                            <strong>{hasResetToken ? "Buat password baru" : "Link reset tidak valid"}</strong>
                        </div>

                        {!hasResetToken && (
                            <div className="public-auth-note danger">
                                Link reset tidak memiliki token aman. Minta link baru dari halaman lupa password.
                            </div>
                        )}

                        {hasResetToken && (
                            <>
                                <div className="public-auth-form">
                                    <Input
                                        className="public-auth-input"
                                        placeholder="Masukkan Password"
                                        value={password}
                                        type={!visible ? "password" : "text"}
                                        onChange={(e) => {
                                            if (!verifyLength(e.target.value, 16)) {
                                                setPassword(e.target.value)
                                            }
                                        }}
                                    />
                                    <Input
                                        className="public-auth-input"
                                        placeholder="Konfirmasi Password"
                                        value={retypePass}
                                        type={!visible ? "password" : "text"}
                                        onChange={(e) => {
                                            if (!verifyLength(e.target.value, 16)) {
                                                setRetypePass(e.target.value)
                                            }
                                        }}
                                    />
                                </div>

                                <div className="public-auth-link-row">
                                    <button type="button" onClick={() => setVisible(!visible)}>
                                        {visible ? "Sembunyikan Password" : "Tampilkan Password"}
                                    </button>
                                </div>
                            </>
                        )}

                        <div className="public-auth-link-row">
                            <button type="button" onClick={() => navigation("/login")}>
                                Kembali login
                            </button>
                        </div>

                        <div className="public-auth-actions">
                            <MainButton
                                title={hasResetToken ? "Reset Password" : "Minta Link Baru"}
                                onClick={handleClick}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )

    return (
        <LoadingScreen
            loading={isLoad}
            children={children}
        />
    )
}

export default ResetPassword
